import React from 'react'
import { LockIcon } from 'components/index'

const EventLock = () => (
  <div className="flex items-center justify-center bg-black rounded-full h-12 w-12 md:h-14 md:w-14">
    <LockIcon className="text-white w-3 md:w-3.5" />
  </div>
)

export default EventLock
